import React, { useState, useEffect } from "react";
import TopTitle from "./TopTitle";
import axios from "axios";
import { comma, uncomma } from "./common";
import Pagination from "react-js-pagination";
import Bottom_menu from "./Bottom_menu";
import { formatDate } from "./common";
import { instance, currentDate, returnDate, dateReset } from "./common";
import DatePicker, { registerLocale } from "react-datepicker";
import ko from "date-fns/locale/ko";
import calendar from "./img/sigong_nav/month.png";

function priceReturn(data) {
  let price = 0;
  data.forEach(function (v) {
    price += Number(v.jungsan_price);
  });

  return comma(price);
}

function LoadData({ history }) {
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState([]);

  const ppp = 10;
  const [page, setPage] = useState(
    window.sessionStorage.getItem("page")
      ? Number(window.sessionStorage.getItem("page"))
      : 1
  );
  const [total, setTotal] = useState(0);

  const [r_ipgo, setR_ipgo] = useState(
    window.sessionStorage.getItem("change_date")
      ? window.sessionStorage.getItem("change_date")
      : progressDate(0)
  );
  const [active, setActive] = useState(
    window.sessionStorage.getItem("date_active")
      ? window.sessionStorage.getItem("date_active")
      : 0
  );

  const [nowDate, setNowDate] = useState(
    window.sessionStorage.getItem("change_date_now")
      ? window.sessionStorage.getItem("change_date_now")
      : progressDate(0)
  );
  const [startDate, setStartDate] = useState(
    active === "custom"
      ? returnDate(window.sessionStorage.getItem("startDate"))
      : ""
  );
  const [endDate, setEndDate] = useState(
    active === "custom"
      ? returnDate(window.sessionStorage.getItem("endDate"))
      : ""
  );
  const [updateCheck, setUpdateCheck] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [selectValue, setSelectValue] = useState("re_date");
  const [searchCheck, setSearchCheck] = useState(false);

  console.log("nowDate : ", nowDate);
  console.log("r_ipgo : ", r_ipgo);
  console.log("active : ", active);

  console.log("startDate : ", startDate);
  const startChange = (date) => {
    window.sessionStorage.setItem("date_active", "custom");
    window.sessionStorage.setItem("change_date_now", formatDate(date));
    window.sessionStorage.setItem("startDate", formatDate(date));
    setStartDate(date);
    setNowDate(formatDate(date));
    setActive("custom");
  };
  const endChange = (date) => {
    window.sessionStorage.setItem("date_active", "custom");
    window.sessionStorage.setItem("change_date", formatDate(date));
    window.sessionStorage.setItem("endDate", formatDate(date));
    setEndDate(date);
    setR_ipgo(formatDate(date));
    setActive("custom");
  };

  const parsedsigong = JSON.parse(window.sessionStorage.result);
  const si_id = parsedsigong.u_sigong;

  let obj = {
    page: page,
    ppp: ppp,
    si_id: si_id,
    r_ipgo: r_ipgo,
    nowDate: nowDate,
    keyword: keyword,
    selectValue: selectValue,
    active: active,
    bp_ok_chk: 0,
  };

  useEffect(() => {
    const fetchData = async () => {
      instance.post("/reserve/v3/maechul-progress", obj).then(function (res) {
        console.log("res : ", res.data);
        setData(res.data.rows);
        setTotalData(res.data.total_rows);
        setTotal(res.data.totalCount);
      });
    };
    fetchData();
  }, [page, ppp, si_id, r_ipgo, nowDate, updateCheck, searchCheck, active]);

  const tabSearch = {
    whiteSpace: "nowrap",
  };
  const grayLine = {
    border: "solid 1px lightgray",
  };

  const onClick = (e) => {
    const { day } = e.target.dataset;
    setNowDate(progressDate(0));
    setR_ipgo(progressDate(day));
    setStartDate("");
    setEndDate("");
    setActive(day);
    dateReset();
    window.sessionStorage.setItem("date_active", day);
    window.sessionStorage.setItem("change_date_now", progressDate(0));
    window.sessionStorage.setItem("change_date", progressDate(day));
  };
  const pageChange = (pageNumber) => {
    window.sessionStorage.setItem("page", pageNumber);
    setPage(pageNumber);
  };
  const ab = {
    position: "absolute",
    right: "23px",
    top: "4px",
    width: "20px",
  };

  const ab2 = {
    position: "absolute",
    right: "8px",
    top: "4px",
    width: "20px",
  };

  const goLink = (cate, seq) => {
    if (cate === "k" || cate === "sun" || cate === "btob") {
      window.sessionStorage.setItem("optionValue", cate);
      history.push("/work?seq=" + seq + "&cate=" + cate + "&end=1");
    } else {
      history.push("/work?seq=" + seq + "&end=1");
    }
  };

  const changeStatus = (e) => {
    const { id, cate } = e.target.dataset;
    let tableName = "hy_reserve";
    if (cate === "k" || cate === "sun" || cate === "btob") {
      tableName = "k_reserve";
    }
    const common = {
      r_status: e.target.value,
    };

    if (e.target.value === "완료") {
      common.r_enddate = currentDate();
    } else if (e.target.value === "진행중") {
      common.r_ipgo = currentDate();
    }

    instance
      .post(`/common/update`, {
        table: tableName,
        common: common,
        field: "seq",
        value: id,
      })
      .then(function (res) {
        alert("진행상태가 변경되었습니다.");
        setUpdateCheck(!updateCheck);
      });
  };
  // const excelDownload = (columns) => {
  //     const excelData = []
  //     columns.forEach(function(v){
  //         let obj = {예약번호:v.re_date,프로젝트명:cateMake(v.cate),정산금액:v.jungsan_price,진행상태:v.r_status}
  //         excelData.push(obj)
  //     })
  //     console.log('columns : ', columns)
  //     console.log('excelData : ', excelData)
  //     const ws = xlsx.utils.json_to_sheet(excelData);
  //     const wb = xlsx.utils.book_new();

  //     xlsx.utils.book_append_sheet(wb, ws, '정산리스트');
  //     xlsx.writeFile(wb, `정산리스트.xlsx`);
  // };

  // const cateMake = (cated) => {
  //     let name = '';
  //     if(cated === 'k'){
  //         name = 'K-Solution 카케어서비스';
  //     }else if(cated === 'sun'){
  //         name = '썬가드 신차패키지';
  //     }else if(cated === 'btob'){
  //         name = 'BtoB 서비스';
  //     }else{
  //         name = cated
  //     }
  //     return name
  // }

  return (
    <>
      <div className="container">
        <div className="row mb-4 pl-0 pr-0">
          <div className="pl-0 col-6" style={{ position: "relative" }}>
            <DatePicker
              locale="ko"
              dateFormat="yyyy-MM-dd"
              className="progress-datepicker form-control text-center text-primary culDate"
              selected={startDate}
              onChange={startChange}
            />
            <img src={calendar} style={ab} />
          </div>
          <div className="pr-0 col-6" style={{ position: "relative" }}>
            <DatePicker
              locale="ko"
              dateFormat="yyyy-MM-dd"
              className="progress-datepicker form-control text-center text-primary culDate"
              selected={endDate}
              onChange={endChange}
            />
            <img src={calendar} style={ab2} />
          </div>
        </div>

        <div className="row mb-3 px-0 text-center">
          {active * 1 === 0 ? (
            <div
              className="day-span col px-0 font-weight-bold active"
              onClick={onClick}
              data-day={0}
            >
              오늘
            </div>
          ) : (
            <div
              className="day-span col px-0 font-weight-bold"
              onClick={onClick}
              data-day={0}
            >
              오늘
            </div>
          )}
          {active * 1 === 7 ? (
            <div
              className="day-span col px-0 font-weight-bold active"
              onClick={onClick}
              data-day={7}
            >
              일주일
            </div>
          ) : (
            <div
              className="day-span col px-0 font-weight-bold"
              onClick={onClick}
              data-day={7}
            >
              일주일
            </div>
          )}
          {active * 1 === 15 ? (
            <div
              className="day-span col px-0 font-weight-bold active"
              onClick={onClick}
              data-day={15}
            >
              15일
            </div>
          ) : (
            <div
              className="day-span col px-0 font-weight-bold"
              onClick={onClick}
              data-day={15}
            >
              15일
            </div>
          )}
          {active * 1 === 30 ? (
            <div
              className="day-span col px-0 font-weight-bold active"
              onClick={onClick}
              data-day={30}
            >
              한달
            </div>
          ) : (
            <div
              className="day-span col px-0 font-weight-bold"
              onClick={onClick}
              data-day={30}
            >
              한달
            </div>
          )}
          {active * 1 === 60 ? (
            <div
              className="day-span col px-0 font-weight-bold active"
              onClick={onClick}
              data-day={60}
            >
              두달
            </div>
          ) : (
            <div
              className="day-span col px-0 font-weight-bold"
              onClick={onClick}
              data-day={60}
            >
              두달
            </div>
          )}
          {active === "전체" ? (
            <div
              className="day-span col px-0 font-weight-bold active"
              onClick={onClick}
              data-day="전체"
            >
              전체
            </div>
          ) : (
            <div
              className="day-span col px-0 font-weight-bold"
              onClick={onClick}
              data-day="전체"
            >
              전체
            </div>
          )}
        </div>
        <div style={grayLine}></div>

        <div className="">
          <table className="table">
            <thead>
              <tr>
                <th>총 정산</th>
                <th className="text-right"> {priceReturn(totalData)} 원</th>
              </tr>
            </thead>
            <tbody></tbody>
            <tfoot></tfoot>
          </table>
        </div>
        <div className="row px-0 mb-4">
          <div className="pl-0 col-3">
            <select
              className="form-control"
              value={selectValue}
              onChange={(e) => setSelectValue(e.target.value)}
              style={{ fontSize: 12 }}
            >
              <option value="re_date">주문번호</option>
              <option value="u_name">이름</option>
              <option value="u_phone">전화번호</option>
              <option value="u_car_number">차량번호</option>
              <option value="u_car_number2">차대번호</option>
              <option value="product">서비스상품명</option>
              <option value="u_car_name">차종</option>
            </select>
          </div>
          <div className="px-0 col-7">
            <input
              className="form-control"
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              style={{ fontSize: 12, border: "1px solid lightgray" }}
            />
          </div>
          <div className="col-2 pr-0">
            <span
              className="btn btn-dark btn-block"
              onClick={() => setSearchCheck(!searchCheck)}
            >
              검색
            </span>
          </div>
        </div>
        <div className="row p-0">
          <table className="table table-bordered text-center">
            <thead>
              <tr>
                <th>No</th>
                <th>예약번호</th>
                <th>프로젝트명</th>
                <th>정산금액</th>
                <th>진행상태</th>
              </tr>
            </thead>
            <tbody>
              {data.map((v, i) => (
                <tr key={i}>
                  <td>{total - i}</td>
                  <td>
                    <span
                      onClick={() => goLink(v.cate, v.seq)}
                      style={{ color: "#06f", cursor: "pointer" }}
                    >
                      {v.re_date}
                    </span>
                  </td>
                  <td>{getProjectName(v.cate)}</td>
                  <td>{v.jungsan_price}</td>
                  <td>
                    <select
                      value={v.r_status}
                      data-id={v.seq}
                      onChange={changeStatus}
                      data-cate={v.cate}
                    >
                      <option value="신규" style={{ fontSize: "12px" }}>
                        신규
                      </option>
                      <option value="진행중" style={{ fontSize: "12px" }}>
                        진행중
                      </option>
                      <option value="완료" style={{ fontSize: "12px" }}>
                        완료
                      </option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot></tfoot>
          </table>
        </div>
      </div>
      {/* <div className='text-right pr-4 d-none'>
                <span className='btn btn-secondary' onClick={() => excelDownload(totalData)}>엑셀다운로드</span>
            </div> */}
      <div className="text-center">
        <Pagination
          activePage={page}
          itemsCountPerPage={ppp}
          totalItemsCount={total}
          pageRangeDisplayed={10}
          onChange={pageChange}
        />
      </div>
      <div className="text-right pr-4">
        <div
          className="btn btn-primary"
          onClick={() => history.push("/maechul-success")}
        >
          정산완료리스트 보기
        </div>
      </div>
    </>
  );
}

function getProjectName(named) {
  let changeName = named;
  if (named === "k") {
    changeName = "K-Solution 카케어서비스";
  } else if (named === "sun") {
    changeName = "썬가드 신차패키지";
  } else if (named === "btob") {
    changeName = "BtoB 서비스";
  }
  return changeName;
}

function progressDate(type) {
  const d = new Date();
  let result;
  if (type === "전체") {
    result = "전체";
  } else if (type === 0) {
    result = formatDate(d);
  } else {
    const date = new Date(d.getFullYear(), d.getMonth(), d.getDate() - type);
    result = formatDate(date);
  }

  return result;
}

function MaechulList({ history }) {
  const pbottom = {
    paddingBottom: "90px",
  };
  return (
    <>
      <div style={pbottom}>
        <TopTitle title="정산리스트" />
        <LoadData history={history} />
        <Bottom_menu />
      </div>
    </>
  );
}

export default MaechulList;
